import css from './errors.module.scss';

import _ from 'lodash';
import { memo, useEffect } from 'react';

type TErrorLike = { message: string; stack?: string };
type TProps = {
  error: TErrorLike | string;
  showStackTrace?: boolean;
  log?: boolean;
};

const ErrorPane = ({ error, showStackTrace = false, log = true }: TProps) => {
  useEffect(() => {
    if (log) {
      console.error(error);
    }
  }, [error]);

  return (
    <div className={css.errorPanel}>
      {_.isString(error) ? error : error.message}
      {!_.isString(error) && showStackTrace && error.stack && (
        <pre>{error.stack}</pre>
      )}
    </div>
  );
};

export default memo(ErrorPane);
